// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__22y7F","date":"CreditCardExpiryDate_date__3blVT"};